import * as React from 'react'
import moment from 'moment'
import { Timeline as AntdTimeline } from 'antd'
import { FC } from 'react'

import { Event } from 'shared/types'

interface TimelineItemProps {
  eventAt: string
  eventDescription: string
}

const TimeLineItem: FC<TimelineItemProps> = ({ eventDescription, eventAt }) => {
  return (
    <AntdTimeline.Item>
      {eventDescription} <strong>{moment(eventAt).fromNow()}</strong>
    </AntdTimeline.Item>
  )
}

interface TimelineProps {
  events: Event[]
}

const Timeline: FC<TimelineProps> = ({ events }) => {
  return (
    <>
      <AntdTimeline mode="left">
        {events.map((event, i) => (
          <TimeLineItem key={i} eventAt={event.createdAt} eventDescription={event.description} />
        ))}
      </AntdTimeline>
    </>
  )
}

export default Timeline
